<script>
export { render as render };
export { staticRenderFns as staticRenderFns };
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card",
    [
      _c(
        "b-container",
        { staticClass: "dispute-status" },
        [
          _c("b-row", { staticClass: "d-flex justify-content-between" }, [
            _c("div", { staticClass: "pl-0", attrs: { lg: "8" } }, [
              _c("div", { staticClass: "d-flex mb-1" }, [
                _c(
                  "h3",
                  { staticClass: "mb-0 back_button" },
                  [
                    _c("BackButton"),
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("disputeStatus.Dispute-Status"))),
                    ]),
                  ],
                  1
                ),
              ]),
            ]),
            _c(
              "div",
              {
                staticClass: "order-num pl-0 text-lg-right",
                attrs: { lg: "4", sm: "6" },
              },
              [
                _c("div", [
                  _c("div", { staticClass: "order-created-text d-inline" }, [
                    _vm._v(
                      " " + _vm._s(_vm.$t("disputeStatus.Order-number")) + " "
                    ),
                  ]),
                  _c(
                    "div",
                    { staticClass: "d-inline" },
                    [
                      _vm._v(" " + _vm._s(_vm.adOrderDispute.adOrderId) + " "),
                      _c("Copy", {
                        directives: [
                          {
                            name: "b-tooltip",
                            rawName: "v-b-tooltip.hover.v-primary",
                            modifiers: { hover: true, "v-primary": true },
                          },
                        ],
                        attrs: { title: _vm.$t("wallet.Copy") },
                        on: {
                          click: function ($event) {
                            return _vm.copy(_vm.item.value)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _c("div", [
                  _c("div", { staticClass: "order-created-text d-inline" }, [
                    _vm._v(
                      " " + _vm._s(_vm.$t("disputeStatus.Time-created")) + " "
                    ),
                  ]),
                  _c("div", { staticClass: "d-inline" }, [
                    _vm._v(_vm._s(_vm.adOrderDispute.createdTime)),
                  ]),
                ]),
              ]
            ),
            _c("div", { staticClass: "chat", attrs: { sm: "6" } }, [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "b-modal",
                      rawName: "v-b-modal.modal-chat-window-open",
                      modifiers: { "modal-chat-window-open": true },
                    },
                  ],
                  attrs: { variant: "outline-primary" },
                },
                [_c("ChatIcon")],
                1
              ),
            ]),
          ]),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                {
                  staticClass: "pt-2 pr-0 pl-0 pr-lg-2 plg-0",
                  attrs: { lg: "8", sm: "12" },
                },
                [
                  _c("div", { staticClass: "order-created-left" }, [
                    _c(
                      "div",
                      { staticClass: "mr-0" },
                      [
                        _c("Stepper", {
                          key: _vm.updateState,
                          attrs: { steps: _vm.steps },
                        }),
                      ],
                      1
                    ),
                    _vm.activeStep == 1
                      ? _c("div", { staticClass: "step-1" }, [
                          !_vm.isCounterParty
                            ? _c(
                                "div",
                                { staticClass: "mr-0" },
                                [
                                  _c("Dispute", {
                                    attrs: {
                                      remainingTime: _vm.remainingTime,
                                      isCounterParty: _vm.isCounterParty,
                                      updateDispute: _vm.updateDispute,
                                    },
                                  }),
                                ],
                                1
                              )
                            : _c(
                                "div",
                                { staticClass: "mr-0" },
                                [
                                  _c("NegotiationFailed", {
                                    attrs: {
                                      remainingTime: _vm.remainingTime,
                                      isCounterParty: _vm.isCounterParty,
                                      updateDispute: _vm.updateDispute,
                                      adOrderDispute: _vm.adOrderDispute,
                                    },
                                  }),
                                ],
                                1
                              ),
                          _c(
                            "div",
                            { staticClass: "mr-0" },
                            [
                              _c("DisputeDetails", {
                                attrs: {
                                  adOrderDispute: _vm.adOrderDispute,
                                  isVisible: true,
                                },
                              }),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                    _vm.activeStep == 2
                      ? _c("div", { staticClass: "step-2" }, [
                          !_vm.isCounterParty
                            ? _c(
                                "div",
                                { staticClass: "mr-0" },
                                [
                                  _c("NegotiationFailed", {
                                    attrs: {
                                      remainingTime: _vm.remainingTime,
                                      isCounterParty: _vm.isCounterParty,
                                      updateDispute: _vm.updateDispute,
                                      adOrderDispute: _vm.adOrderDispute,
                                    },
                                  }),
                                ],
                                1
                              )
                            : _c(
                                "div",
                                { staticClass: "mr-0" },
                                [
                                  _c("Dispute", {
                                    attrs: {
                                      remainingTime: _vm.remainingTime,
                                      isCounterParty: _vm.isCounterParty,
                                    },
                                  }),
                                ],
                                1
                              ),
                          _c(
                            "div",
                            { staticClass: "mr-0" },
                            [
                              _c("DisputeDetails", {
                                attrs: { adOrderDispute: _vm.adOrderDispute },
                              }),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                    _vm.activeStep == 3
                      ? _c("div", { staticClass: "step-3" }, [
                          _c(
                            "div",
                            { staticClass: "mr-0" },
                            [
                              _c("Escalate", {
                                attrs: {
                                  adOrderDispute: _vm.adOrderDispute,
                                  isCounterParty: _vm.isCounterParty,
                                  updateDispute: _vm.updateDispute,
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "mr-0" },
                            [
                              _c("DisputeDetails", {
                                attrs: { adOrderDispute: _vm.adOrderDispute },
                              }),
                            ],
                            1
                          ),
                          _vm.adOrderDispute.disputeStatus === "UNDER_REVIEW"
                            ? _c(
                                "div",
                                { staticClass: "mr-0" },
                                [
                                  _c("DisputeComents", {
                                    attrs: {
                                      adOrderDispute: _vm.adOrderDispute,
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ])
                      : _vm._e(),
                    _vm.activeStep == 4
                      ? _c("div", { staticClass: "step-4" }, [
                          _c(
                            "div",
                            { staticClass: "mr-0" },
                            [
                              _c("DisputeDetails", {
                                attrs: { adOrderDispute: _vm.adOrderDispute },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "mr-0" },
                            [
                              _c("DisputeComents", {
                                attrs: { adOrderDispute: _vm.adOrderDispute },
                              }),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ]
              ),
              _c(
                "b-col",
                {
                  staticClass: "mt-2 pr-0 pl-0 plg-0",
                  attrs: { lg: "4", sm: "12" },
                },
                [
                  _c("ChatMessage", {
                    staticClass: "hide-mobile-view",
                    attrs: { counterUserData: _vm.counterUserData },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: "modal-chat-window-open",
            size: "md",
            "hide-footer": "",
            centered: "",
          },
        },
        [
          _c(
            "div",
            { staticClass: "chat-b-r" },
            [
              _c("ChatMessage", {
                attrs: { counterUserData: _vm.counterUserData },
              }),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true



//# sourceURL=webpack:///./src/views/p2p-buy/DisputeStatus.vue?./node_modules/cache-loader/dist/cjs.js?%7B%22cacheDirectory%22:%22node_modules/.cache/vue-loader%22,%22cacheIdentifier%22:%229dcd27b4-vue-loader-template%22%7D!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options

import * as bootstrapvue from 'bootstrap-vue';
import assets_rashi_coin_copy_svg from '@/assets/rashi-coin/copy.svg';
import core_components_chat_Message_vue from '@core/components/chat/Message.vue';
import layouts_components_Stepper_vue from '@/layouts/components/Stepper.vue';
import assets_rashi_coin_send_svg from '@/assets/rashi-coin/send.svg';
import assets_rashi_coin_image_svg from '@/assets/rashi-coin/image.svg';
import assets_rashi_coin_message_svg from '@/assets/rashi-coin/message.svg';
import core_components_dispute_Dispute_vue from '@core/components/dispute/Dispute.vue';
import core_components_dispute_DisputeComment_vue from '@core/components/dispute/DisputeComment.vue';
import core_components_dispute_NegotiationFailed_vue from '@core/components/dispute/NegotiationFailed.vue';
import core_components_dispute_DisputeDetails_vue from '@core/components/dispute/DisputeDetails.vue';
import core_components_dispute_Escalate_vue from '@core/components/dispute/Escalate.vue';
import core_components_dispute_DisputeResolved_vue from '@core/components/dispute/DisputeResolved.vue';
import * as vuex from 'vuex';
import utils_clipboard from '@/utils/clipboard';
import utils_constants from '@/utils/constants';
import core_components_toastification_ToastificationContent_vue from '@core/components/toastification/ToastificationContent.vue';
import libs_api_api from '@/libs/api/api';
import layouts_components_BackButton_vue from '@/layouts/components/BackButton.vue';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





















export default ({
  render,
  staticRenderFns,
  components: {
    BCard: bootstrapvue["BCard"],
    BContainer: bootstrapvue["BContainer"],
    BAvatar: bootstrapvue["BAvatar"],
    BButton: bootstrapvue["BButton"],
    BRow: bootstrapvue["BRow"],
    BCol: bootstrapvue["BCol"],
    BLink: bootstrapvue["BLink"],
    Copy: assets_rashi_coin_copy_svg,
    BInputGroup: bootstrapvue["BInputGroup"],
    BAlert: bootstrapvue["BAlert"],
    BForm: bootstrapvue["BForm"],
    BFormInput: bootstrapvue["BFormInput"],
    BInputGroup: bootstrapvue["BInputGroup"],
    BInputGroupPrepend: bootstrapvue["BInputGroupPrepend"],
    BInputGroupAppend: bootstrapvue["BInputGroupAppend"],
    ChatMessage: core_components_chat_Message_vue,
    Stepper: layouts_components_Stepper_vue,
    Gallery: assets_rashi_coin_image_svg,
    Send: assets_rashi_coin_send_svg,
    Dispute: core_components_dispute_Dispute_vue,
    BFormGroup: bootstrapvue["BFormGroup"],
    ChatIcon: assets_rashi_coin_message_svg,
    DisputeComents: core_components_dispute_DisputeComment_vue,
    NegotiationFailed: core_components_dispute_NegotiationFailed_vue,
    DisputeDetails: core_components_dispute_DisputeDetails_vue,
    Escalate: core_components_dispute_Escalate_vue,
    DisputeResolved: core_components_dispute_DisputeResolved_vue,
    BackButton: layouts_components_BackButton_vue
  },
  directives: {
    "b-tooltip": bootstrapvue["VBTooltip"]
  },
  computed: {
    ...vuex.mapState("user", ["user"])
  },
  data() {
    return {
      updateState: 0,
      activeStep: 0,
      steps: [{
        title: this.$t("Dispute-Status-pop.Dispute-Raised"),
        status: ""
      }, {
        title: this.$t("Dispute-Status-pop.Discuss-with-Counterparty"),
        status: ""
      }, {
        title: this.$t("Dispute-Status-pop.Support-Review"),
        status: ""
      }, {
        title: this.$t("Dispute-Status-pop.Dispute-Resolved"),
        status: ""
      }],
      adOrderDispute: {},
      remainingTime: "",
      isCounterParty: false,
      timer: null,
      endTime: "",
      intervalId: null,
      counterUserData: {}
    };
  },
  mounted() {
    if (this.$route.params.id) {
      this.getDispute();
    } else {
      this.$router.go(-1);
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  },
  methods: {
    async copy(text) {
      await utils_clipboard.apply(this, [`${text}`]);
    },
    calculateTime() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
      if (this.adOrderDispute) {
        this.endTime = new Date(this.adOrderDispute.counterPartyRespDeadLine + "Z").getTime() || new Date().getTime();
        this.updateRemainingTime(this.endTime);
        this.timer = setInterval(() => {
          this.updateRemainingTime(this.endTime);
        }, 1000);
      }
    },
    updateRemainingTime() {
      let currentTime = new Date().getTime(); // Get current time in milliseconds

      let remainingTime = Math.max(0, this.endTime - currentTime);
      let hours = Math.floor(remainingTime / (1000 * 60 * 60));
      let minutes = Math.floor(remainingTime % (1000 * 60 * 60) / (1000 * 60));
      let seconds = Math.floor(remainingTime % (1000 * 60) / 1000);
      this.remainingTime = `${this.padZero(hours)}:${this.padZero(minutes)}:${this.padZero(seconds)}`;
      if (!hours && !minutes && !seconds) {
        if (this.timer) {
          clearInterval(this.timer);
          this.timer = null;
          this.organizedSteps();
        }
      }
    },
    padZero(num) {
      return num < 10 ? `0${num}` : num;
    },
    async getDispute() {
      try {
        const res = await new libs_api_api().api({
          method: "GET",
          url: `p2p/dispute/${this.$route.params.id}`
        }, {}, {
          isLoading: true
        });
        if (res && res.adOrderDispute && res.adOrderDispute.id) {
          let paymentTxDocUrlType = await utils_constants.getFileType(res.adOrderDispute.proofs.paymentTxDocUrl);
          this.adOrderDispute = {
            ...res.adOrderDispute,
            paymentTxDocUrlType,
            createdTime: utils_constants.dateFormat(res.adOrderDispute.createdTime)
          };
          this.counterUserData = res.counterUserData || {};
          this.calculateTime();
          this.organizedSteps();
        } else if (res && res.error && res.error.message) {
          this.$toast({
            component: core_components_toastification_ToastificationContent_vue,
            props: {
              title: res.error.message,
              icon: "EditIcon",
              variant: "danger"
            }
          });
        }
      } catch (error) {
        this.$toast({
          component: core_components_toastification_ToastificationContent_vue,
          props: {
            title: error,
            icon: "EditIcon",
            variant: "danger"
          }
        });
      }
    },
    async updateDispute(disputeStatus) {
      try {
        this.getDispute();
        const res = await new libs_api_api().api({
          method: "post",
          url: `p2p/dispute/update`
        }, {
          id: this.adOrderDispute.id,
          disputeStatus,
          resolution: null
        }, {
          isLoading: true
        });
        if (res && res.result && res.result.requestStatus == "SUCCESS") {
          this.getDispute();
        } else if (res && res.error && res.error.message) {
          this.$toast({
            component: core_components_toastification_ToastificationContent_vue,
            props: {
              title: res.error.message,
              icon: "EditIcon",
              variant: "danger"
            }
          });
        }
      } catch (error) {
        this.$toast({
          component: core_components_toastification_ToastificationContent_vue,
          props: {
            title: error,
            icon: "EditIcon",
            variant: "danger"
          }
        });
      }
    },
    setStep(index) {
      for (let i = 0; i < index; i++) {
        this.steps[i].status = "success";
      }
    },
    startFetchStatusInterval() {
      if (!this.intervalId) {
        this.intervalId = setInterval(this.getOrderStatus, utils_constants["messageInterval"] * 1000);
      }
    },
    async getOrderStatus() {
      try {
        this.isLoading = true;
        const res = await new libs_api_api().api({
          method: "GET",
          url: `p2p/dispute/${this.adOrderDispute.id}/status`
        }, {}, {});
        if (res && res.orderDisputeStatus && this.adOrderDispute.disputeStatus !== res.orderDisputeStatus) {
          this.adOrderDispute.disputeStatus = res.orderDisputeStatus;
          this.organizedSteps();
          if (["CANCELLED", "AGREEMENT_REACHED", "ACCEPTED", "REJECTED", "RESOLVED"].includes(res.orderDisputeStatus)) {
            this.getDispute();
          }
        } else if (res && res.error && res.error.message) {
          this.$toast({
            component: core_components_toastification_ToastificationContent_vue,
            props: {
              title: res.error.message,
              icon: "EditIcon",
              variant: "danger"
            }
          });
        }
      } catch (error) {
        this.$toast({
          component: core_components_toastification_ToastificationContent_vue,
          props: {
            title: error,
            icon: "EditIcon",
            variant: "danger"
          }
        });
      }
    },
    organizedSteps() {
      if (this.adOrderDispute.disputeStatus === "INITIATED") {
        if (!this.timer) {
          this.setStep(1);
          this.activeStep = 2;
        } else {
          this.setStep(0);
          this.activeStep = 1;
        }
        if (this.adOrderDispute.userId === this.user.id) {
          this.startFetchStatusInterval();
        }
      }
      if (this.adOrderDispute.disputeStatus === "AGREEMENT_REACHED_REQUEST") {
        this.setStep(1);
        this.activeStep = 2;
        if (this.adOrderDispute.userId === this.user.id) {
          this.startFetchStatusInterval();
        }
      } else if (["UNDER_REVIEW", "NEGOTIATION_FAILED"].includes(this.adOrderDispute.disputeStatus)) {
        this.setStep(2);
        this.activeStep = 3;
        this.startFetchStatusInterval();
      } else if (["CANCELLED", "AGREEMENT_REACHED", "ACCEPTED", "REJECTED", "RESOLVED"].includes(this.adOrderDispute.disputeStatus)) {
        this.setStep(4);
        this.activeStep = 4;
        if (this.intervalId) {
          clearInterval(this.intervalId);
          this.intervalId = null;
        }
      }
      if (this.adOrderDispute && this.adOrderDispute.userId && this.adOrderDispute.userId === this.user.id) {
        this.isCounterParty = false;
      } else if (this.adOrderDispute && this.adOrderDispute.userId && this.adOrderDispute.userId !== this.user.id) {
        this.isCounterParty = true;
      }
    }
  }
});

//# sourceURL=webpack:///./src/views/p2p-buy/DisputeStatus.vue?./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options
</script>

<style scoped>
.dispute-status .order-created-text {
  color: #707a8a;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
}
.dispute-status .ol-text {
  color: var(--text-black-color);
  font-weight: 400;
  line-height: 27px;
}
.dispute-status .counterparty-alert {
  font-weight: 400;
}
[dir] .dispute-status .counterparty-alert {
  margin: 12px 0px 10px 0px;
}
.dispute-status .counterparty-alert-second {
  font-weight: 400;
}
[dir] .dispute-status .counterparty-alert-second {
  margin: 10px 0px 10px 0px;
}
@media (min-width: 991px) {
.chat {
    display: none;
}
}
@media (max-width: 991px) {
.hide-mobile-view {
    display: none;
}
}
.order-created-left {
  max-height: calc(100vh - 216px);
  overflow-y: auto;
}
[dir=ltr] .order-created-left {
  padding-right: 10px;
}
[dir=rtl] .order-created-left {
  padding-left: 10px;
}
[dir] .chat-b-r {
  margin-top: -10px;
}
</style>
